import { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { store } from 'Store';
import { clearFields, setAvatar } from "Store/LoginInfoSlice";
import { useNavigate } from 'react-router-dom';
import { httpLogin } from "Utils/httpLogin";
import useBoradcast from 'Utils/useBroadcast';
import { Image, DropdownButton, Dropdown, ButtonGroup, Stack, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Avatar from 'Images/Avatar.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { STATUSES, ERROR_MESSAGES } from 'Utils/constants';
import { setGlobalErrorStatus } from 'Components/StatusHandling';
import { PATHS } from 'Utils/PagePaths';
import { getProfileImage } from 'Containers/Private/UserProfile/UserProfilePicture/EditUserProfilePictureAxiosFuncs';
import { Link } from 'react-router-dom';
import { isTextEllipsisActive } from 'Utils/utilityFunctions';

const ProfileMenu = () => {

  const USER_INFO_ELIPSIS_LENGTH = 30;

  const updateAvatarChannel = new BroadcastChannel("User_Avatar");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { message, sendMessage } = useBoradcast("auth_channel");
  const loginInfo = useSelector(state => state.loginInfo);
  // faChevronRight or faChevronDown
  const [profileMenuExpandFlag, setProfileMenuExpandFlag] = useState(false);

  const emailRef = useRef(null);
  const [emailCut, setEmailCut] = useState(false);

  // menu items 
  const profileMenuItemList = [
    {
      text: "My Profile",
      path: "/manage/editUserProfile"
    },
    {
      text: "Reset Password",
      path: "/manage/resetUserPassword"
    },
    {
      text: "Two-Factor Authentication",
      path: "/manage/setupMfa"
    },
    // TODO:!!! 09/24/2026 to revert after pro release
    // {
    //   text: "Profile Picture",
    //   path: "/manage/editUserProfilePicture"
    // }
  ]

  const handleProfileMenu = () => {
    setProfileMenuExpandFlag(!profileMenuExpandFlag);
  }

  const handleDirect = (path) => {
    //console.log("print out handleDirect", path);

    if (path === "") {
      return;
    }

    navigate(path);
  }

  const handleLogout = async () => {
    const res = await logout();

    navigate(PATHS.public['Sign In']);
  }

  // api to logout
  const logout = async () => {

    for (let i = 0; i <= sessionStorage.getItem("validateAccessInterval"); i++) {
      window.clearInterval(i);
    }

    const res = httpLogin.post('/auth/logout', {}, {
      headers: {
        "Authorization": "Bearer " + loginInfo.token
      }
    }).then(() => {
      dispatch(clearFields(loginInfo.initialState));
      //console.log("set logout from the auth channel", sessionStorage.getItem("validateAccessInterval"));
      sendMessage({
        token: "Bearer " + loginInfo.token,
        status: STATUSES.LOG_OUT.text
      });
    }).catch(function (error) {
      return error.response;
    });

    return res;
  }

  // api to validate token
  const validateAccess = async (token) => {

    const url = "/api/validation";

    const res = await httpLogin.post(url, {}, {
      headers: {
        "Authorization": token
      }
    })

    return res;
  }

  // get initials from first name and last name
  const getInitials = (firstName, lastName) => {
    if (firstName && lastName) {
      return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
    }

    return "UNK";
  }

  // get text with elipsis if the length is longer than maxLength
  const getTextElipsis = (text, maxLength) => {
    if (text && text.length > maxLength) {
      return text.substring(0, maxLength - 4) + "...";
    }

    return text;
  }

  // render tooltip for the elipsis text
  const renderTooltip = (content, id) => (props) => (
    <Tooltip id={id}
      className='user-info-elipsis'
      {...props}
    >
      <div className='py-1'>
        {content}
      </div>
    </Tooltip>
  );

  useEffect(() => {
    if (message?.status == STATUSES.LOG_OUT.text) {
      //console.log("Start validation from auth channel", message);
      if (store.getState().loginInfo?.token) {
        let tokenAuth = "Bearer " + store.getState().loginInfo.token;

        for (let i = 0; i <= sessionStorage.getItem("validateAccessInterval"); i++) {
          window.clearInterval(i);
        }

        validateAccess(tokenAuth)
          .then((res) => {
            //console.log("validateAccess profileMenu", tokenAuth);
          }).catch((error) => {
            //console.log("validateAccess profileMenu", error);
            setGlobalErrorStatus({
              dispatch: dispatch,
              popupData: {
                visible: true,
                title: ERROR_MESSAGES.DATA_ERROR.title,
                msg: ERROR_MESSAGES.DATA_ERROR.message,
                showContactHelp: true
              },
              redirect: {
                redirect: false,
                redirectFirst: false,
                path: "",
                data: {}
              },
              error: error
            });
          })
      }
    }
  }, [message]);

  useEffect(() => {
    getProfileImage("Bearer " + loginInfo.token)
      .then((res) => {
        if (res?.data?.size > 0) {
          //console.log("get User Profile Pic from header dispatch", res);
          dispatch(setAvatar(window.URL.createObjectURL(res?.data)));
        }
      });


  }, []);

  useEffect(() => {
    if (emailRef?.current && isTextEllipsisActive(emailRef.current)) {
      setEmailCut(true);
    }
    else {
      setEmailCut(false);
    }
  }, [emailRef])
  // notify to sync user avatar on other tabs
  useEffect(() => {
    updateAvatarChannel.onmessage = ev => {
      //console.log("receive update avatar message", ev.data);
      dispatch(setAvatar(ev.data));
    };

    return () => {
      updateAvatarChannel.close();
    };
  }, [updateAvatarChannel]);

  return (
    <div className="me-1 d-inline-block" >
      {/**TODO:!!! 09/24/2026 to revert after pro release  */}
      {/*<div id="profile-menu-container" className="" > */}
      <DropdownButton
        className=""
        id={"profileMenu"}
        variant={"bg-white"}
        onToggle={handleProfileMenu}
        title={<>
          {/**TODO:!!! 09/24/2026 to revert after pro release  */}
          {/* {loginInfo?.avatar ?
            <Image
              src={loginInfo?.avatar}
              alt="Uploaded Preview Avatar"
              className='user-avatar-uploaded'
            ></Image>
            :
            <div className='d-flex user-avatar text-center p-0 align-content-center justify-content-center flex-wrap'>
              {getInitials(loginInfo.firstName, loginInfo.lastName)}
            </div>
            // <span className='d-inline-block user-avatar me-2 pt-2'>{getInitials(loginInfo.firstName, loginInfo.lastName)}</span>
          } */}
          {/* &nbsp;&nbsp; */}
          {/*
          <FontAwesomeIcon className="profileMenuIcon" style={{ "color": "white" }} icon={faChevronDown} /> */}
          <Image alt="Avatar" src={Avatar} />
          &nbsp;&nbsp;
          {profileMenuExpandFlag ?
            <FontAwesomeIcon className="profileMenuIcon" style={{ "color": "white" }} icon={faChevronRight} /> :
            <FontAwesomeIcon className="profileMenuIcon" style={{ "color": "white" }} icon={faChevronDown} />
          }
        </>}
        align="end"
      >

        {/**TODO:!!! 09/24/2026 to revert after pro release  */}
        {/* <Dropdown.Header eventKey="1" className='px-3 pt-3 pb-14px d-flex flex-column gap-2'>
          <div className='userProfileInfo gap-3 justify-content-between d-flex flex-row align-items-center'>
            <div className="userInfoContainer">
              <div className='userName body semibold color-base-black'>{loginInfo.firstName}&nbsp;{loginInfo.lastName}</div>
              {
                emailCut != null && emailCut == true
                  ?
                  <OverlayTrigger placement="bottom" overlay={<Tooltip id="userNameTooltip" className="public-tooltip-light ">{loginInfo.username}</Tooltip>}>
                    <div className='userEmail bodyS regular color-base-darkergray' ref={emailRef} >
                      {loginInfo.username}
                    </div>
                  </OverlayTrigger>
                  :
                  <div className='userEmail bodyS regular color-base-darkergray' ref={emailRef} >
                    {loginInfo.username}
                  </div>
              }

            </div>
            <div className='userIcon'>
              {
                loginInfo?.avatar ?
                  <Image
                    src={loginInfo?.avatar}
                    alt="Uploaded Preview Avatar"
                    className='user-avatar-uploaded'
                  ></Image>
                  :
                  <div className='d-flex user-avatar text-center p-0 align-content-center justify-content-center flex-wrap'>
                    {getInitials(loginInfo.firstName, loginInfo.lastName)}
                  </div>
              }
            </div>
          </div>
          <div>
            <div className='psoName bodyS regular color-base-darkgray'>{loginInfo.psoName}</div>
          </div>
        </Dropdown.Header> */}
        <Dropdown.Item eventKey="1" className='bg-transparent disabled pb-2'>
          <Stack direction="horizontal" gap={3} className='userProfileInfo'>
            <div className="ps-2">
              <span className='userName'>{loginInfo.firstName}&nbsp;{loginInfo.lastName}</span>
              <br />
              <span className='userEmail'>{loginInfo.username}</span>
            </div>
            <div className='userIcon'><Image alt="" src={Avatar} />&nbsp; <FontAwesomeIcon className="profileMenuIcon" icon={faChevronRight} /></div>
          </Stack>
          <div><span className='psoName ps-2'>{loginInfo.psoName}</span></div>
        </Dropdown.Item>
        <Dropdown.Divider className="my-0 mb-4px" />
        {/**Loop menu items */}
        {profileMenuItemList.map((item, index) => (
          <Dropdown.Item as={Link} to={item.path} eventKey={index + 1} className='userProfileItem py-12px px-16px' onClick={() => handleDirect(item.path)}>
            <div className='bodyS regular'>{item.text}</div>
          </Dropdown.Item>
        ))}
        <Dropdown.Divider className="my-0" />
        <Dropdown.Item eventKey="7" className='userProfileItem py-12px px-16px mb-4px' onClick={handleLogout}>
          <div className='bodyS regular'>Sign out</div>
        </Dropdown.Item>
      </DropdownButton>
    </div>
  )
}

export default ProfileMenu;